import { Component } from '@angular/core'
import { ImageGroup } from '@spartacus/core'
import {ICON_TYPE, ProductImagesComponent} from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'

@Component({
    selector: 'eb-product-images',
    templateUrl: './eb-product-images.component.html',
    styleUrls: ['./eb-product-images.component.scss'],
    standalone: false
})
export class EbProductImagesComponent extends ProductImagesComponent {
    protected readonly ICON_TYPE = ICON_TYPE;

  get createThumbnailsFromParentClass() {
    // eslint-disable-next-line @typescript-eslint/dot-notation
    return this['createThumbs']
  }
    isActive(thumb: ImageGroup): Observable<boolean> {
    return this.mainMediaContainer.pipe(
      filter(Boolean),
      map((main: ImageGroup) => {
        const thumbMedia = thumb?.zoom ?? thumb?.product
        const mainMedia = main?.zoom ?? main?.product
        const url1 = thumbMedia?.url
        const url2 = mainMedia?.url
        return url1 && url1 === url2
      })
    )
  }
}
